import PubSub from 'underpub-js';
import slick from 'slick-carousel';

var ImageCarousel = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-ImageCarousel',
  };

  $.extend(true, this.options, options);
};

ImageCarousel.prototype.init = function() {
  const self = this;

  self.$slides = self.options.$el.find(`.${self.data.baseClass}__slides`);
  self.$prevArrow = self.options.$el.find(
    `.${self.data.baseClass}__arrow--prev`,
  );
  self.$nextArrow = self.options.$el.find(
    `.${self.data.baseClass}__arrow--next`,
  );

  self.initSlider();
};

ImageCarousel.prototype.initSlider = function() {
  const self = this;

  self.$slides.slick({
    fade: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    nextArrow: self.$nextArrow,
    prevArrow: self.$prevArrow,
  });
};

export default ImageCarousel;
